export class CollapseLongContent extends HTMLDivElement {
    private contentWrapper: HTMLDivElement | null = null;
    private button: HTMLButtonElement | null = null;
    private maxHeight: number = 0;
    private ctaLabel: string = 'Voir plus';
    private ctaHideLabel: string = 'Masquer';

    constructor() {
        super();
    }

    connectedCallback() {
        const dataHeight = this.getAttribute('data-height');
        this.ctaLabel = this.getAttribute('data-cta') || 'Voir plus';
        this.ctaHideLabel = this.getAttribute('data-cta-hide') || 'Masquer';

        if (!dataHeight) return;

        this.maxHeight = parseInt(dataHeight, 10);

        this.contentWrapper = document.createElement('div');
        this.contentWrapper.className = 'inner';

        while (this.firstChild) {
            this.contentWrapper.appendChild(this.firstChild);
        }

        this.appendChild(this.contentWrapper);

        requestAnimationFrame(() => {
            if (this.contentWrapper && this.contentWrapper.scrollHeight > this.maxHeight) {
                this.collapse();
            }
        });
    }

    private expand() {
        this.classList.remove('is-truncated');
        if (this.contentWrapper) {
            this.contentWrapper.style.maxHeight = 'none';
        }
        if (this.button) {
            this.button.textContent = this.ctaHideLabel;
            this.button.removeEventListener('click', this.expandHandler);
            this.button.addEventListener('click', this.collapseHandler);
        }
    }

    private collapse() {
        this.classList.add('is-truncated');
        if (this.contentWrapper) {
            this.contentWrapper.style.maxHeight = `${this.maxHeight}px`;
        }
        if (!this.button) {
            this.button = document.createElement('button');
            this.button.type = 'button';
            this.button.className = 'btn btn-sm btn-link fs-12 text-nowrap fw-semibold';
            this.button.textContent = this.ctaLabel;
            this.button.addEventListener('click', this.expandHandler);
            this.appendChild(this.button);
        } else {
            this.button.textContent = this.ctaLabel;
            this.button.removeEventListener('click', this.collapseHandler);
            this.button.addEventListener('click', this.expandHandler);
        }
    }

    private expandHandler = () => this.expand();
    private collapseHandler = () => this.collapse();
}
